import { Tag } from '@nespresso-design-system/components';
import type { JSX } from 'preact';
import type { Product } from '@/domain/Product';
import SkeletonText from '@/widgets/components/controls/Skeleton/SkeletonText';

export type ProductLabelSectionProps = {
  product: Product;
} & JSX.HTMLAttributes<HTMLElement>;

export default function ProductLabelSection({
  product
}: ProductLabelSectionProps) {
  const label = product.highlightLabels?.[0]?.label;

  if (!label) return null;

  return (
    <section>
      <Tag label={label} />
    </section>
  );
}

ProductLabelSection.Skeleton = function Skeleton() {
  return (
    <section>
      <SkeletonText />
    </section>
  );
};
